import Button from 'components/Button';
import Modal from 'components/Modal/Modal';
import { useLanguage } from 'context/AppContext';
import React, { useState, useCallback } from 'react';
import * as Styles from '../SATOVideosPage.styles';

interface RejectConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onReject: (comment: string) => void;
}

const RejectConfirmationModal: React.FC<RejectConfirmationModalProps> = ({ open, onClose, onReject }) => {
  const [language] = useLanguage();
  const [comment, setComment] = useState('');

  const handleReject = useCallback(() => {
    onReject(comment);
    /* eslint-disable */
  }, [comment]);

  return (
    <Modal open={open} close={onClose} width="40rem">
      <h2>{language.Sato.updateStatus.rejectTray}</h2>
      <p>{language.Sato.updateStatus.rejectTrayConfirm}</p>
      <Styles.CommentInput
        variant="outlined"
        fullWidth
        multiline
        placeholder={language.Sato.videosPage.addComment}
        value={comment}
        onChange={e => setComment(e.target.value)}
      />
      <Button fullWidth onClick={handleReject} disabled={comment.length < 1}>
        {language.ConfirmModal.confirm}
      </Button>
    </Modal>
  );
};

export default RejectConfirmationModal;
